/* AJH — Soft Registration: PDF / Artwork / Editorial (site-wide) */
(function () {
  const MODAL_ID = "ajhPdfGate";

  // PDF (literature library)
  const PDF_STORAGE_KEY    = "ajh_pdf_register_seen_at";
  const PDF_COOLDOWN_DAYS  = 14;
  const PDF_DELAY_MS       = 8000;

  // Artwork (private viewing room)
  const ARTWORK_STORAGE_KEY   = "ajh_artwork_engage_seen_at";
  const ARTWORK_COOLDOWN_DAYS = 3;
  const ARTWORK_DELAY_MS      = 42000;

  // Editorial (pages + articles, excluding contact/PVR/viewing rooms)
  const EDITORIAL_STORAGE_KEY   = "ajh_editorial_engage_seen_at";
  const EDITORIAL_COOLDOWN_DAYS = 2;
  const EDITORIAL_DELAY_MS      = 15000;

  // Thank-you state hold (after successful submit)
  const THANKS_MS = 4000;

  function now() { return Date.now(); }
  function msDays(d) { return d * 24 * 60 * 60 * 1000; }

  function seenRecently(key, days) {
    try {
      const v = localStorage.getItem(key);
      if (!v) return false;
      const t = parseInt(v, 10);
      if (!Number.isFinite(t)) return false;
      return (now() - t) < msDays(days);
    } catch (e) {
      return true; // fail closed
    }
  }

  function markSeen(key) {
    try { localStorage.setItem(key, String(now())); } catch (e) {}
  }

  function isPdfHref(href) {
    if (!href) return false;
    return /\.pdf(\?|$)/i.test(href);
  }

  function getPdfTitleFromLink(a) {
    const t = (a.getAttribute("data-pdf-title") || a.textContent || "").trim();
    return t || "Catalogue PDF";
  }

  function els() {
    const gate = document.getElementById(MODAL_ID);
    if (!gate) return null;

    return {
      gate,
      panel:        gate.querySelector(".ajh-pdfgate__panel"),
      title:        document.getElementById("ajhPdfGateTitle"),
      lead:         document.getElementById("ajhPdfGateLead"),

      barActions:   document.getElementById("ajhPdfGateBarActions"),
      primaryBtn:   document.getElementById("ajhPdfGatePrimary"),

      form:         document.getElementById("ajhPdfGateForm"),
      thanks:       document.getElementById("ajhPdfGateThanks"),
      iframe:       document.getElementById("ajhPdfGate_iframe"),

      formContext:  document.getElementById("ajhPdfGate_form_context"),
      pdfTitle:     document.getElementById("ajhPdfGate_pdf_title"),
      pdfUrl:       document.getElementById("ajhPdfGate_pdf_url"),
      artworkTitle: document.getElementById("ajhPdfGate_artwork_title"),
      artworkUrl:   document.getElementById("ajhPdfGate_artwork_url"),
      artworkImage: document.getElementById("ajhPdfGate_artwork_image"),
      pageUrl:      document.getElementById("ajhPdfGate_page_url")
    };
  }

  function clearContextFields($) {
    if ($.pdfTitle)     $.pdfTitle.value     = "";
    if ($.pdfUrl)       $.pdfUrl.value       = "";
    if ($.artworkTitle) $.artworkTitle.value = "";
    if ($.artworkUrl)   $.artworkUrl.value   = "";
    if ($.artworkImage) $.artworkImage.value = "";
    if ($.pageUrl)      $.pageUrl.value      = window.location.href;
  }

  function setMode(mode, payload) {
    const $ = els();
    if (!$) return;

    // Defensive reset
    $.gate.classList.remove("is-expanded", "is-thanks");
    $.gate.dataset.mode = mode || "pdf";

    document.documentElement.classList.add("ajh-pdfgate--open");

    if ($.thanks)     $.thanks.hidden     = true;
    if ($.form)       $.form.hidden       = false;
    if ($.barActions) $.barActions.hidden = false;

    clearContextFields($);

    if (mode === "artwork") {
      // Artwork: bar -> expand -> embedded form
      if ($.title) $.title.textContent = "PRIVATE VIEWING ROOM";
      if ($.lead)  $.lead.textContent  =
        "access is available by request.";
      if ($.primaryBtn) $.primaryBtn.textContent = "Request access";

      if ($.formContext)  $.formContext.value  = "artwork_register";
      if ($.artworkTitle) $.artworkTitle.value = payload.artwork_title || "";
      if ($.artworkUrl)   $.artworkUrl.value   = payload.artwork_url   || window.location.href;
      if ($.artworkImage) $.artworkImage.value = payload.artwork_image || "";

    } else if (mode === "editorial") {
      // Editorial: open form directly
      if ($.title) $.title.textContent = "STAY INFORMED";
      if ($.lead)  $.lead.textContent  =
        "Writings, private views and new releases. Nothing else.";
      if ($.barActions) $.barActions.hidden = true;
      $.gate.classList.add("is-expanded");

      if ($.formContext) $.formContext.value = "editorial_updates";

    } else {
      // PDF default: fired after the user closes a literature PDF tab
      if ($.title) $.title.textContent = "STAY INFORMED";
      if ($.lead)  $.lead.textContent  =
        "New writings, private views and occasional releases. Nothing else";
      if ($.primaryBtn) $.primaryBtn.textContent = "Register";

      if ($.formContext) $.formContext.value = "pdf_register";
      if ($.pdfTitle)    $.pdfTitle.value    = payload.pdf_title || "";
      if ($.pdfUrl)      $.pdfUrl.value      = payload.pdf_url   || "";
    }

    // Spanish display copy only; leave triggers and form values untouched.
    if (document.documentElement.lang.toLowerCase().split('-')[0] === 'es') {
      if ($.title) $.title.textContent = mode === 'artwork'
        ? 'SALA PRIVADA' : 'MANTÉNGASE INFORMADO';
      if ($.lead) $.lead.textContent = mode === 'artwork'
        ? 'El acceso está disponible previa solicitud.'
        : 'Nuevos textos, presentaciones privadas y lanzamientos ocasionales. Nada más.';
      if ($.primaryBtn) $.primaryBtn.textContent = mode === 'artwork'
        ? 'Solicitar acceso' : 'Registrarse';

      const labels = $.gate.querySelectorAll('.ajh-pdfgate__labeltext');
      ['Nombre', 'Correo electrónico', 'Añadir un mensaje (opcional)'].forEach((value, i) => {
        if (labels[i]) labels[i].textContent = value;
      });
      $.gate.querySelectorAll('.ajh-pdfgate__barbtn--quiet, .ajh-pdfgate__dismiss')
        .forEach(btn => { btn.textContent = 'Ahora no'; });

      const submit = $.gate.querySelector('.ajh-pdfgate__submit');
      if (submit) submit.textContent = mode === 'artwork' ? 'Enviar solicitud' : 'Suscribirme';
      const thanks = $.gate.querySelector('.ajh-pdfgate__thanksMsg');
      if (thanks) thanks.textContent = 'Gracias. Hemos tomado nota de su interés.';
      const close = $.gate.querySelector('.ajh-pdfgate__close');
      if (close) close.setAttribute('aria-label', 'Cerrar');

      const consent = $.gate.querySelector('.ajh-pdfgate__consent span');
      if (consent && consent.firstChild) consent.firstChild.textContent = 'CONECTAR — ';
      const privacy = $.gate.querySelector('.ajh-pdfgate__consent a');
      if (privacy) privacy.textContent = 'lea nuestra política de privacidad';
    }
  }

  function openModal(payload) {
    const $ = els();
    if (!$) return false;

    // Never open on top of an already-open modal
    if ($.gate.classList.contains("is-open")) return false;

    const mode = payload && payload.mode ? payload.mode : "pdf";
    setMode(mode, payload || {});

    $.gate.classList.add("is-open");
    $.gate.setAttribute("aria-hidden", "false");
    return true;
  }

  function closeModal() {
    const $ = els();
    if (!$) return;

    $.gate.classList.remove("is-open", "is-expanded", "is-thanks");
    $.gate.setAttribute("aria-hidden", "true");
    document.documentElement.classList.remove("ajh-pdfgate--open");

    if ($.thanks) $.thanks.hidden = true;
    if ($.form) {
      $.form.hidden = false;
      try { $.form.reset(); } catch (e) {}
    }
  }

  function markSeenForCurrentMode() {
    const $ = els();
    if (!$) return;

    const mode = $.gate.dataset.mode || "pdf";
    if (mode === "artwork")        markSeen(ARTWORK_STORAGE_KEY);
    else if (mode === "editorial") markSeen(EDITORIAL_STORAGE_KEY);
    else                           markSeen(PDF_STORAGE_KEY);
  }

  /* ----- Dismissal: X button, "Not now", ESC, and click anywhere outside the panel ----- */
  function wireDismissals() {
    // X and "Not now" buttons (anything tagged data-ajh-pdfgate-close)
    document.addEventListener("click", (e) => {
      const closeHit = e.target.closest("[data-ajh-pdfgate-close]");
      if (!closeHit) return;

      e.preventDefault();
      markSeenForCurrentMode();
      closeModal();
    });

    // ESC key
    document.addEventListener("keydown", (e) => {
      if (e.key !== "Escape") return;
      const $ = els();
      if ($ && $.gate.classList.contains("is-open")) {
        markSeenForCurrentMode();
        closeModal();
      }
    });

    // Click outside the panel — dismisses the popup. The page-level click
    // (link, image, etc.) still proceeds normally because the container is
    // pointer-events:none, so this is a passive observer, not a blocker.
    document.addEventListener("click", (e) => {
      const $ = els();
      if (!$ || !$.gate.classList.contains("is-open")) return;
      if (e.target.closest(".ajh-pdfgate__panel")) return; // inside panel: ignore
      markSeenForCurrentMode();
      closeModal();
    });
  }

  function wireExpand() {
    document.addEventListener("click", (e) => {
      const btn = e.target.closest("[data-ajh-pdfgate-expand]");
      if (!btn) return;

      e.preventDefault();
      const $ = els();
      if (!$) return;

      $.gate.classList.add("is-expanded");
      const first = $.gate.querySelector('input[name="contact[name]"]');
      if (first) setTimeout(() => first.focus(), 50);
    });
  }

  function wireForm() {
    const $ = els();
    if (!$ || !$.form || !$.thanks || !$.iframe) return;

    let didSubmit = false;

    const sendBtn = $.form.querySelector('button[type="submit"], input[type="submit"]');
    if (sendBtn) {
      sendBtn.addEventListener("click", () => { didSubmit = true; }, true);
    }

    $.form.addEventListener("submit", (ev) => {
      // iOS/Safari: surface native validation immediately
      try {
        if (!$.form.checkValidity()) {
          ev.preventDefault();
          $.form.reportValidity();
          return;
        }
      } catch (e) {}

      didSubmit = true;
      markSeenForCurrentMode();

      $.gate.classList.add("is-thanks");
      $.form.hidden   = true;
      $.thanks.hidden = false;

      setTimeout(() => {
        closeModal();
        didSubmit = false;
      }, THANKS_MS);
    }, true);

    $.iframe.addEventListener("load", () => {
      if (!didSubmit) return;
    }, true);
  }

  function fireGA(pdfUrl, pdfTitle) {
    try {
      if (typeof window.gtag === "function") {
        window.gtag("event", "pdf_open", {
          pdf_url: pdfUrl,
          pdf_title: pdfTitle,
          page_location: window.location.href
        });
      }
    } catch (e) {}
  }

  function getSiteContext() {
    const b = document.body;
    if (!b) return {};

    const ds = b.dataset || {};
    return {
      pageType:        ds.pageType        || "",
      templateName:    ds.templateName    || "",
      templateSuffix:  ds.templateSuffix  || "",
      artworkHandle:   ds.artworkHandle   || "",
      artworkTitle:    ds.artworkTitle    || "",
      artworkUrl:      ds.artworkUrl      || "",
      artworkImage:    ds.artworkImage    || ""
    };
  }

  function isArtworkPage(ctx) {
    return ctx.pageType === "product" && ctx.templateSuffix === "artwork";
  }

  function isEditorialPage(ctx) {
    if (ctx.pageType === "product") return false;
    // Shopify's `template.name` is only ever the base family — "page",
    // "article", "blog" — never the alternate template suffix. The
    // exclusion strings below ("contact", "viewing-room", "pvr") only
    // ever appear in `template.suffix` (e.g. page.viewing-room.liquid),
    // so matching against templateName alone could never exclude any of
    // them — this is why the manuscript reader (page.manuscript-review)
    // was falling through to the generic editorial popup along with
    // every other suffixed page template. Matching against the suffix
    // (with name kept as a fallback) fixes this for manuscript-review
    // and restores the originally-intended exclusions.
    const name = ((ctx.templateSuffix || "") + " " + (ctx.templateName || "")).toLowerCase();
    if (name.indexOf("contact") !== -1)            return false;
    if (name.indexOf("viewing-room") !== -1)       return false;
    if (name.indexOf("pvr") !== -1)                return false;
    if (name.indexOf("manuscript-review") !== -1)  return false;
    return (ctx.pageType === "page" || ctx.pageType === "article" || ctx.pageType === "blog");
  }

  function scheduleArtworkEngage(ctx) {
    if (seenRecently(ARTWORK_STORAGE_KEY, ARTWORK_COOLDOWN_DAYS)) return;

    let fired = false;
    const startedAt = now();

    const fire = () => {
      if (fired) return;
      fired = true;

      const opened = openModal({
        mode: "artwork",
        artwork_handle: ctx.artworkHandle,
        artwork_title:  ctx.artworkTitle,
        artwork_url:    ctx.artworkUrl || window.location.href,
        artwork_image:  ctx.artworkImage
      });
      if (opened) markSeen(ARTWORK_STORAGE_KEY);

      window.removeEventListener("scroll", onScroll);
    };

    const onScroll = () => {
      if (fired) return;
      const doc = document.documentElement;
      const scrollTop = (window.pageYOffset || doc.scrollTop || 0);
      const height    = Math.max(doc.scrollHeight - doc.clientHeight, 1);
      const pct       = scrollTop / height;
      // Late-stage nudge, not an early interruption
      if (pct >= 0.90 && (now() - startedAt) >= 20000) fire();
    };

    setTimeout(() => {
      if (document.hidden) return;
      fire();
    }, ARTWORK_DELAY_MS);

    window.addEventListener("scroll", onScroll, { passive: true });
  }

  function scheduleEditorialEngage(ctx) {
    if (seenRecently(EDITORIAL_STORAGE_KEY, EDITORIAL_COOLDOWN_DAYS)) return;

    let fired = false;

    const fire = () => {
      if (fired) return;
      if (seenRecently(EDITORIAL_STORAGE_KEY, EDITORIAL_COOLDOWN_DAYS)) return;
      fired = true;

      const opened = openModal({ mode: "editorial" });
      if (opened) markSeen(EDITORIAL_STORAGE_KEY);

      document.removeEventListener("mouseout", onExitIntent);
    };

    // Exit intent — desktop pointers only. Fires when the cursor leaves
    // toward the top of the viewport (address bar / tab strip) with no
    // relatedTarget, the standard "about to leave the tab" signal.
    // Gated on (pointer: fine) so touch scrolling on mobile, which fires
    // unrelated mouseout events, can never trigger it.
    const isDesktopPointer =
      window.matchMedia && window.matchMedia("(pointer: fine)").matches;

    function onExitIntent(e) {
      if (fired) return;
      if (e.clientY > 0) return;
      if (e.relatedTarget || e.toElement) return;
      fire();
    }

    if (isDesktopPointer) {
      document.addEventListener("mouseout", onExitIntent);
    }

    setTimeout(() => {
      if (document.hidden) return;
      fire();
    }, EDITORIAL_DELAY_MS);
  }

  function initPdfIntercept() {
    let timer = null;
    let lastPayload = null;

    document.addEventListener("click", (e) => {
      const a = e.target.closest("a[href]");
      if (!a) return;

      const href = a.getAttribute("href");
      if (!isPdfHref(href)) return;
      if ((a.getAttribute("data-pdf-register") || "").toLowerCase() === "off") return;

      e.preventDefault();

      const absUrl   = new URL(href, window.location.href).toString();
      const pdfTitle = getPdfTitleFromLink(a);

      window.open(absUrl, "_blank", "noopener");
      fireGA(absUrl, pdfTitle);

      if (seenRecently(PDF_STORAGE_KEY, PDF_COOLDOWN_DAYS)) return;

      lastPayload = {
        mode:      "pdf",
        pdf_url:   absUrl,
        pdf_title: pdfTitle,
        page_url:  window.location.href
      };

      const readyAt = now() + PDF_DELAY_MS;

      function maybeShow() {
        if (!lastPayload) return;
        if (seenRecently(PDF_STORAGE_KEY, PDF_COOLDOWN_DAYS)) return;
        if (document.hidden) return;

        if (now() >= readyAt) {
          openModal(lastPayload);
          document.removeEventListener("visibilitychange", maybeShow, false);
          lastPayload = null;
        }
      }

      if (timer) clearTimeout(timer);
      timer = setTimeout(maybeShow, PDF_DELAY_MS);
      document.addEventListener("visibilitychange", maybeShow, false);
    }, { capture: true });
  }

  function init() {
    wireDismissals();
    wireExpand();
    wireForm();

    initPdfIntercept();

    const ctx = getSiteContext();

    if (isArtworkPage(ctx))   { scheduleArtworkEngage(ctx);   return; }
    if (isEditorialPage(ctx)) { scheduleEditorialEngage(ctx); return; }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();